import { IAuditHistoryRecord } from "@/services/store-access-query";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { getActionLabel, getActionColor } from "./audit-history.utils";

interface AuditHistoryContentProps {
  data: IAuditHistoryRecord[];
}

export const AuditHistoryContent: React.FC<AuditHistoryContentProps> = ({ data }) => {
  if (data.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        Nenhum registro de histórico encontrado.
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {data.map((record) => (
        <div
          key={record.id}
          className="border rounded-lg p-4 hover:bg-gray-50 transition-colors"
        >
          <div className="flex items-center justify-between mb-2">
            <span
              className={`px-2 py-1 rounded-full text-xs font-medium ${getActionColor(record.action)}`}
            >
              {getActionLabel(record.action)}
            </span>
            <span className="text-sm text-gray-500">
              {format(new Date(record.created_at), "dd/MM/yyyy 'às' HH:mm", {
                locale: ptBR,
              })}
            </span>
          </div>

          <p className="text-sm text-gray-700 mb-2">{record.information}</p>

          <div className="flex flex-wrap gap-4 text-xs text-gray-500">
            <div>
              <span className="font-medium">Responsável:</span> {record.email}
            </div>
            <div>
              <span className="font-medium">IP:</span> {record.ip}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
